import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import { createContext, useContext, useEffect, useState } from 'react'

type Props = {
  children: ReactElement
}

const CampaignContext = createContext<object | undefined>(undefined)

const CampaignProvider = ({ children }: Props) => {
  const router = useRouter()

  // Extract relevant query parameters
  const {
    BrochureRCode,
    BrochureRC,
    TestdriveRCode,
    TestDriveRCode,
    testdriveRC,
    CampaignID,
    CampaignId,
    campaignID,
    CID,
    ac,
    mc,
    utmCampaign,
  } = router.query

  // Determine the campaign value
  const campaign =
    CampaignID ||
    CampaignId ||
    campaignID ||
    CID ||
    ac ||
    Cookies.get('CampaignID') ||
    ''

  // State to hold UTM parameters
  const [utms, setUtms] = useState<object | null>(null)

  // Function to retrieve and parse UTM cookie
  function getUTMCookie(cookieName: string) {
    const cookieValue = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${cookieName}=`))
    if (cookieValue) {
      const jsonString = decodeURIComponent(cookieValue.split('=')[1] || '')
      try {
        const utmsVal = JSON.parse(jsonString)
        return utmsVal
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to parse UTM cookie JSON:', e)
      }
    }
    return null
  }

  // useEffect to ensure the code runs on the client side
  useEffect(() => {
    const utmParams = getUTMCookie('utm_cookie') || {}
    setUtms(utmParams)
  }, [])

  // Determine other campaign-related values
  const brochure =
    BrochureRCode || BrochureRC || Cookies.get('BrochureRcode') || ''
  const testDrive =
    TestdriveRCode ||
    TestDriveRCode ||
    testdriveRC ||
    Cookies.get('TestdriveRCode') ||
    ''
  const media = mc || ''
  const utm = utmCampaign || ''

  // Initial state to be provided through context
  const initialState = {
    campaign,
    brochure,
    testDrive,
    media,
    utm,
    utms,
  }

  return (
    <CampaignContext.Provider value={initialState}>
      {children}
    </CampaignContext.Provider>
  )
}

// Hook to use the campaign context
const useCampaign = () => {
  return useContext(CampaignContext)
}

export { CampaignProvider, useCampaign }
